
  (function () {
  function initStoneShapeArrows(root) {
    const scroller = root.querySelector("[data-shape-scroll]");
    const btnL = root.querySelector(".jci-shape-arrow--left");
    const btnR = root.querySelector(".jci-shape-arrow--right");
    if (!scroller || !btnL || !btnR) return;

    const update = () => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      const left = scroller.scrollLeft;

      // show left arrow only if we can scroll left
      root.classList.toggle("is-overflow-left", left > 1);

      // show right arrow only if we can scroll right
      root.classList.toggle("is-overflow-right", left < max - 1);
    };

    const step = () => Math.max(220, Math.floor(scroller.clientWidth * 0.8));

    btnL.addEventListener("click", () => {
      scroller.scrollBy({ left: -step(), behavior: "smooth" });
    });

    btnR.addEventListener("click", () => {
      scroller.scrollBy({ left: step(), behavior: "smooth" });
    });

    scroller.addEventListener("scroll", update, { passive: true });

    // Keep correct on resize + dynamic content
    window.addEventListener("resize", () => requestAnimationFrame(update), { passive: true });

    // If items/images load later, this keeps arrows correct
    const ro = new ResizeObserver(update);
    ro.observe(scroller);

    // Optional: wheel scroll horizontally (nice UX on desktop)
    scroller.addEventListener(
      "wheel",
      (e) => {
        // if mostly vertical wheel, convert to horizontal scroll
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX) && scroller.scrollWidth > scroller.clientWidth) {
          scroller.scrollLeft += e.deltaY;
          e.preventDefault();
        }
      },
      { passive: false }
    );

    update();
  }

  document.querySelectorAll(".jci-filter-scrollable").forEach(initStoneShapeArrows);
})();
